function initLenis() {
	if (typeof Lenis === "undefined") {
		console.warn("Lenis n’est pas chargé.");

		return null;
	}

	const lenis = new Lenis({
		duration: 1.2,
		smoothWheel: true,
		smoothTouch: false,
		easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
	});

	lenis.on("scroll", ({ scroll }) => {
		document.body.classList.toggle("scrolled", scroll >= 300);

		if (typeof ScrollTrigger !== "undefined") {
			ScrollTrigger.update();
		}
	});

	/*
	 * Synchronise Lenis avec la boucle de rendu de GSAP.
	 * Il ne faut plus utiliser le requestAnimationFrame séparé.
	 */
	if (typeof gsap !== "undefined") {
		gsap.ticker.add((time) => {
			lenis.raf(time * 1000);
		});

		gsap.ticker.lagSmoothing(0);
	} else {
		function raf(time) {
			lenis.raf(time);
			requestAnimationFrame(raf);
		}

		requestAnimationFrame(raf);
	}

	document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
		anchor.addEventListener("click", function (event) {
			const targetId = this.getAttribute("href");

			if (!targetId || targetId === "#" || targetId === "#!") {
				return;
			}

			const target = document.querySelector(targetId);

			if (!target) {
				return;
			}

			event.preventDefault();

			lenis.resize();

			lenis.scrollTo(target, {
				offset: 0,
				duration: 1.2,
				easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
			});
		});
	});

	return lenis;
}

function initScrollAnimations() {
	if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
		return;
	}

	const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	const animations = {
		".u-fade": {
			autoAlpha: 0,
		},

		".u-fade-up": {
			autoAlpha: 0,
			y: 60,
		},

		".u-fade-down": {
			autoAlpha: 0,
			y: -60,
		},

		".u-fade-left": {
			autoAlpha: 0,
			x: 60,
		},

		".u-fade-right": {
			autoAlpha: 0,
			x: -60,
		},

		".u-scale-in": {
			autoAlpha: 0,
			scale: 0.9,
		},

		".u-scale-up": {
			autoAlpha: 0,
			y: 30,
			scale: 0.9,
		},

		".u-rotate-in": {
			autoAlpha: 0,
			y: 40,
			rotation: -4,
		},
	};

	Object.entries(animations).forEach(([selector, fromVars]) => {
		document.querySelectorAll(selector).forEach((element) => {
			const duration = Number(element.dataset.duration) || 0.9;
			const delay = Number(element.dataset.delay) || 0;
			const start = element.dataset.start || "top 88%";
			const ease = element.dataset.ease || "power3.out";
			const distance = Number(element.dataset.distance);

			const initialState = {
				...fromVars,
			};

			/*
			 * Permet de remplacer les distances par défaut.
			 */
			if (Number.isFinite(distance)) {
				if (typeof initialState.x !== "undefined") {
					initialState.x = Math.sign(initialState.x) * distance;
				}

				if (typeof initialState.y !== "undefined") {
					initialState.y = Math.sign(initialState.y) * distance;
				}
			}

			if (reduceMotion) {
				gsap.set(element, {
					autoAlpha: 1,
					x: 0,
					y: 0,
					scale: 1,
					rotation: 0,
				});

				return;
			}

			gsap.fromTo(element, initialState, {
				autoAlpha: 1,
				x: 0,
				y: 0,
				scale: 1,
				rotation: 0,
				duration,
				delay,
				ease,
				overwrite: "auto",
				scrollTrigger: {
					trigger: element,
					start,
					once: true,
				},
			});
		});
	});

	/*
	 * Animation successive des enfants directs.
	 */
	document.querySelectorAll(".u-stagger").forEach((container) => {
		const children = Array.from(container.children);

		if (!children.length) {
			return;
		}

		if (reduceMotion) {
			gsap.set(children, {
				autoAlpha: 1,
				y: 0,
			});

			return;
		}

		gsap.fromTo(
			children,
			{
				autoAlpha: 0,
				y: Number(container.dataset.distance) || 40,
			},
			{
				autoAlpha: 1,
				y: 0,
				duration: Number(container.dataset.duration) || 0.8,
				stagger: Number(container.dataset.stagger) || 0.12,
				ease: container.dataset.ease || "power3.out",
				scrollTrigger: {
					trigger: container,
					start: container.dataset.start || "top 85%",
					once: true,
				},
			},
		);
	});

	/*
	 * Attend que les images, polices et composants aient leur taille finale.
	 */
	ScrollTrigger.refresh();
}

function addLoadedClass() {
	document.body.classList.add("team-loaded");
}

function initIntroParallax() {
	const intro = document.querySelector(".c-intro_wrap");

	if (!intro) return;

	gsap.to(intro, {
		yPercent: -20, // amount of parallax (20% upward)
		ease: "none", // pure linear scrolling
		scrollTrigger: {
			trigger: ".c-intro",
			start: "top bottom", // when section enters viewport
			end: "bottom top", // when section leaves viewport
			scrub: true, // links animation to scroll
		},
	});
}

function initBurgerMenu() {
	const trigger = document.querySelector(".c-nav_burgertrigger");
	const menu = document.querySelector(".c-nav_burger");

	if (!trigger || !menu) {
		return;
	}

	const links = menu.querySelectorAll("a");
	const menuItems = menu.querySelectorAll("li");
	const burgerLines = trigger.querySelectorAll("span");

	if (!links.length || burgerLines.length !== 3) {
		return;
	}

	let isOpen = false;

	const timeline = gsap.timeline({
		paused: true,
		defaults: {
			ease: "power3.inOut",
		},
		onStart: function () {
			menu.style.visibility = "visible";
		},
		onReverseComplete: function () {
			menu.style.visibility = "hidden";
		},
	});

	timeline
		.to(
			menu,
			{
				yPercent: 100,
				opacity: 1,
				duration: 0.65,
			},
			0,
		)
		.to(
			burgerLines[0],
			{
				y: 19,
				rotation: 45,
				duration: 0.35,
			},
			0,
		)
		.to(
			burgerLines[1],
			{
				opacity: 0,
				scaleX: 0,
				duration: 0.2,
			},
			0,
		)
		.to(
			burgerLines[2],
			{
				y: -19,
				rotation: -45,
				duration: 0.35,
			},
			0,
		)
		.fromTo(
			links,
			{
				opacity: 0,
				y: 30,
			},
			{
				opacity: 1,
				y: 0,
				duration: 0.45,
				stagger: 0.08,
				ease: "power2.out",
			},
			"-=0.2",
		)
		.fromTo(
			menuItems,
			{
				"--line-scale": 0,
			},
			{
				"--line-scale": 1,
				duration: 0.4,
				stagger: 0.08,
				ease: "power2.out",
			},
			"<",
		);

	function openMenu() {
		if (isOpen) return;

		isOpen = true;

		document.body.classList.add("menu-open");
		trigger.classList.add("is-active");

		trigger.setAttribute("aria-expanded", "true");
		trigger.setAttribute("aria-label", "Fermer le menu");
		menu.setAttribute("aria-hidden", "false");

		timeline.play();
	}

	function closeMenu() {
		if (!isOpen) return;

		isOpen = false;

		document.body.classList.remove("menu-open");
		trigger.classList.remove("is-active");

		trigger.setAttribute("aria-expanded", "false");
		trigger.setAttribute("aria-label", "Ouvrir le menu");
		menu.setAttribute("aria-hidden", "true");

		timeline.reverse();
	}

	function toggleMenu() {
		if (isOpen) {
			closeMenu();
		} else {
			openMenu();
		}
	}

	trigger.addEventListener("click", toggleMenu);

	links.forEach(function (link) {
		link.addEventListener("click", closeMenu);
	});

	document.addEventListener("keydown", function (event) {
		if (event.key === "Escape") {
			closeMenu();
		}
	});
}

/**
 * Ajoute une classe au header après 300px de scroll.
 */
function initScrolledHeader() {
	const header = document.querySelector(".c-nav");

	if (!header) return;

	let lastScrollY = window.scrollY;
	let ticking = false;

	function updateHeader() {
		const currentScrollY = window.scrollY;

		header.classList.toggle("is-scrolled", currentScrollY > 300);

		if (currentScrollY > lastScrollY) {
			header.classList.add("is-scrolling-down");
			header.classList.remove("is-scrolling-up");
		} else if (currentScrollY < lastScrollY) {
			header.classList.add("is-scrolling-up");
			header.classList.remove("is-scrolling-down");
		}

		// Prevents iOS overscroll from producing invalid values.
		lastScrollY = Math.max(0, currentScrollY);
		ticking = false;
	}

	function handleScroll() {
		if (ticking) return;

		ticking = true;
		window.requestAnimationFrame(updateHeader);
	}

	updateHeader();

	window.addEventListener("scroll", handleScroll, {
		passive: true,
	});
}

function initPlansLightbox() {
	const sections = document.querySelectorAll(".c-planslightbox");

	sections.forEach((section) => {
		const triggers = section.querySelectorAll(".c-plans_trigger");
		const lightboxes = section.querySelectorAll(".c-lightbox");

		let activeLightbox = null;
		let activeTrigger = null;
		let isAnimating = false;

		function openLightbox(lightbox, trigger) {
			if (!lightbox || activeLightbox || isAnimating) return;

			const wrap = lightbox.querySelector(".c-lightbox_wrap");
			const image = lightbox.querySelector(".c-lightbox_wrap img");
			const closeButton = lightbox.querySelector(".c-lightbox_close");

			activeLightbox = lightbox;
			activeTrigger = trigger;
			isAnimating = true;

			document.body.classList.add("lightbox-open");

			lightbox.setAttribute("aria-hidden", "false");

			gsap.killTweensOf([lightbox, wrap, image, closeButton]);

			const timeline = gsap.timeline({
				onComplete: () => {
					isAnimating = false;

					if (closeButton) {
						closeButton.focus();
					}
				},
			});

			timeline
				.set(lightbox, {
					display: "block",
					visibility: "visible",
					pointerEvents: "auto",
				})
				.fromTo(
					lightbox,
					{
						autoAlpha: 0,
					},
					{
						autoAlpha: 1,
						duration: 0.4,
						ease: "power2.out",
					},
				)
				.fromTo(
					image,
					{
						opacity: 0,
						y: 50,
						scale: 0.97,
					},
					{
						opacity: 1,
						y: 0,
						scale: 1,
						duration: 0.65,
						ease: "power3.out",
					},
					"-=0.2",
				)
				.fromTo(
					closeButton,
					{
						opacity: 0,
						rotation: -45,
						scale: 0.8,
					},
					{
						opacity: 1,
						rotation: 0,
						scale: 1,
						duration: 0.4,
						ease: "back.out(1.7)",
					},
					"-=0.45",
				);
		}

		function closeLightbox() {
			if (!activeLightbox || isAnimating) return;

			const lightbox = activeLightbox;
			const image = lightbox.querySelector(".c-lightbox_wrap img");
			const closeButton = lightbox.querySelector(".c-lightbox_close");
			const triggerToRestore = activeTrigger;

			isAnimating = true;

			gsap.killTweensOf([lightbox, image, closeButton]);

			const timeline = gsap.timeline({
				onComplete: () => {
					lightbox.setAttribute("aria-hidden", "true");

					gsap.set(lightbox, {
						display: "none",
						visibility: "hidden",
						pointerEvents: "none",
					});

					document.body.classList.remove("lightbox-open");

					activeLightbox = null;
					activeTrigger = null;
					isAnimating = false;

					if (triggerToRestore) {
						triggerToRestore.focus();
					}
				},
			});

			timeline
				.to([image, closeButton], {
					opacity: 0,
					y: 25,
					duration: 0.25,
					ease: "power2.in",
				})
				.to(
					lightbox,
					{
						autoAlpha: 0,
						duration: 0.35,
						ease: "power2.inOut",
					},
					"-=0.1",
				);
		}

		triggers.forEach((trigger) => {
			trigger.setAttribute("role", "button");
			trigger.setAttribute("tabindex", "0");
			trigger.setAttribute("aria-label", "Agrandir le plan");

			function handleOpen() {
				const lightboxId = trigger.dataset.lightboxId;

				const lightbox = section.querySelector(`.c-lightbox[data-lightbox-id="${lightboxId}"]`);

				openLightbox(lightbox, trigger);
			}

			trigger.addEventListener("click", handleOpen);

			trigger.addEventListener("keydown", (event) => {
				if (event.key === "Enter" || event.key === " ") {
					event.preventDefault();
					handleOpen();
				}
			});
		});

		lightboxes.forEach((lightbox) => {
			const wrap = lightbox.querySelector(".c-lightbox_wrap");
			const closeButton = lightbox.querySelector(".c-lightbox_close");

			lightbox.setAttribute("aria-hidden", "true");

			gsap.set(lightbox, {
				autoAlpha: 0,
				display: "none",
				pointerEvents: "none",
			});

			if (closeButton) {
				closeButton.addEventListener("click", closeLightbox);
			}

			/*
			 * Comme .c-lightbox_wrap couvre actuellement toute la lightbox,
			 * le clic dans son padding représente le clic "à l'extérieur"
			 * de l'image.
			 */
			lightbox.addEventListener("click", (event) => {
				if (event.target === lightbox || event.target === wrap) {
					closeLightbox();
				}
			});
		});

		document.addEventListener("keydown", (event) => {
			if (event.key === "Escape" && activeLightbox) {
				closeLightbox();
			}
		});
	});
}

function initFloorSelector() {
	const sections = document.querySelectorAll(".c-selector_section");

	if (!sections.length) {
		return;
	}

	sections.forEach(function (section) {
		const initialSelector = section.querySelector(".c-selector_initial");

		const floors = section.querySelectorAll(".c-floor");
		const backButtons = section.querySelectorAll(".c-floor_back");
		const mobileSelect = section.querySelector("#c-selector_mobileselect");

		if (mobileSelect) {
			mobileSelect.addEventListener("change", function (event) {
				const floorNumber = Number(event.currentTarget.value);

				if (!Number.isInteger(floorNumber) || floorNumber < 1 || floorNumber > 7) {
					return;
				}

				showFloor(floorNumber);
			});
		}

		if (!initialSelector || !floors.length) {
			return;
		}

		let activeRequestController = null;
		let isNavigating = false;

		const transitionOverlay = document.createElement("div");

		transitionOverlay.className = "c-selector_transition";
		transitionOverlay.setAttribute("aria-hidden", "true");

		section.appendChild(transitionOverlay);

		gsap.set(transitionOverlay, {
			autoAlpha: 0,
		});

		/**
		 * Conserve uniquement les chiffres.
		 */
		function normalizeNumber(value) {
			return String(value || "").replace(/\D/g, "");
		}

		function getFloorNumber(level) {
			if (!level) {
				return null;
			}

			const floorNumber = Number(level.getAttribute("data-floor-index"));

			if (!Number.isInteger(floorNumber) || floorNumber < 1 || floorNumber > 7) {
				console.warn("data-floor-index invalide :", level);

				return null;
			}

			return floorNumber;
		}

		/**
		 * Annule la requête d’unité active.
		 */
		function abortActiveRequest() {
			if (!activeRequestController) {
				return;
			}

			activeRequestController.abort();
			activeRequestController = null;
		}

		/**
		 * Change d’écran derrière une transition légère.
		 *
		 * Les plans SVG ne sont jamais animés directement.
		 */
		function changeView(fromView, toView, callback) {
			if (!fromView || !toView || fromView === toView) {
				isNavigating = false;

				if (callback) {
					callback();
				}

				return;
			}

			gsap.killTweensOf(transitionOverlay);

			const timeline = gsap.timeline({
				onComplete: function () {
					isNavigating = false;

					if (callback) {
						callback();
					}
				},
			});

			timeline
				.set(transitionOverlay, {
					pointerEvents: "auto",
				})
				.to(transitionOverlay, {
					autoAlpha: 1,
					duration: 0.3,
					ease: "power2.inOut",
				})
				.call(function () {
					fromView.hidden = true;
					fromView.setAttribute("aria-hidden", "true");

					toView.hidden = false;
					toView.setAttribute("aria-hidden", "false");
				})
				.to(transitionOverlay, {
					autoAlpha: 0,
					duration: 0.4,
					ease: "power2.inOut",
				})
				.set(transitionOverlay, {
					pointerEvents: "none",
				});
		}

		/**
		 * Cache les étages au chargement initial.
		 */
		function setInitialState() {
			floors.forEach(function (floor) {
				floor.hidden = true;
				floor.setAttribute("aria-hidden", "true");
			});

			initialSelector.hidden = false;
			initialSelector.setAttribute("aria-hidden", "false");
		}

		/**
		 * Associe les CPT aux unités du SVG.
		 */
		function initializeSvgUnits(floor) {
			const cards = floor.querySelectorAll(".c-floor_unitecard[data-unit][data-wp-pid]");

			cards.forEach(function (card) {
				const unitNumber = normalizeNumber(card.dataset.unit);

				const postId = card.dataset.wpPid;
				const isAvailable = card.dataset.available === "1";

				if (!unitNumber || !postId) {
					console.warn("Carte d’unité invalide :", card);

					return;
				}

				const svgUnit = floor.querySelector('.unite[id="_' + unitNumber + '"]');

				if (!svgUnit) {
					console.warn("Aucune zone SVG trouvée pour l’unité " + unitNumber + ".");

					return;
				}

				svgUnit.dataset.wpPid = postId;
				svgUnit.dataset.unit = unitNumber;

				if (!isAvailable) {
					svgUnit.classList.remove("-available");
					svgUnit.removeAttribute("role");
					svgUnit.removeAttribute("tabindex");
					svgUnit.removeAttribute("aria-label");

					return;
				}

				svgUnit.classList.add("-available");
				svgUnit.setAttribute("role", "button");
				svgUnit.setAttribute("tabindex", "0");
				svgUnit.setAttribute("aria-label", "Voir l’unité " + unitNumber);
			});
		}

		/**
		 * Affiche un étage.
		 */
		function showFloor(floorNumber) {
			if (isNavigating) {
				return;
			}

			const floor = section.querySelector('.c-floor[data-floor="' + floorNumber + '"]');

			if (!floor) {
				console.warn("Aucun étage HTML trouvé pour le niveau " + floorNumber + ".");

				return;
			}

			isNavigating = true;
			abortActiveRequest();

			changeView(initialSelector, floor, function () {
				const backButton = floor.querySelector(".c-floor_back");

				if (backButton) {
					backButton.focus();
				}
			});
		}

		/**
		 * Retourne au sélecteur général.
		 */
		function showInitialSelector(event) {
			if (event) {
				event.preventDefault();
			}

			if (isNavigating) {
				return;
			}

			const activeFloor = section.querySelector('.c-floor[aria-hidden="false"]');

			if (!activeFloor) {
				return;
			}

			isNavigating = true;
			abortActiveRequest();

			changeView(activeFloor, initialSelector, function () {
				const firstLevel = initialSelector.querySelector(".niveau");

				if (firstLevel) {
					firstLevel.focus();
				}
			});
		}

		/**
		 * Retire l’état actif des unités.
		 */
		function resetActiveUnits(floor) {
			const activeElements = floor.querySelectorAll([".unite.-active", ".c-floor_unitecard.-active"].join(","));

			activeElements.forEach(function (element) {
				element.classList.remove("-active");
			});
		}

		function showUnitList(floor) {
			if (!floor) {
				return;
			}

			const unitList = floor.querySelector(".c-floor_unites");

			const details = floor.querySelector(".c-floor_details");

			if (!unitList || !details) {
				return;
			}

			abortActiveRequest();
			resetActiveUnits(floor);

			details.hidden = true;
			details.innerHTML = "";

			unitList.hidden = false;
		}

		async function loadUnitData(trigger) {
			const postId = trigger.dataset.wpPid;
			const floor = trigger.closest(".c-floor");

			const unitList = floor ? floor.querySelector(".c-floor_unites") : null;

			const details = floor ? floor.querySelector(".c-floor_details") : null;

			if (!postId || !floor || !unitList || !details) {
				return;
			}

			if (typeof window.g7FloorSelector === "undefined" || !window.g7FloorSelector.ajaxUrl) {
				console.error("La configuration AJAX est absente.");

				return;
			}

			abortActiveRequest();

			const requestController = new AbortController();

			activeRequestController = requestController;

			resetActiveUnits(floor);
			trigger.classList.add("-active");

			floor.classList.add("-loading");

			/*
			 * On cache les cards et on affiche le chargement.
			 */
			unitList.hidden = true;
			details.hidden = false;

			details.innerHTML = '<div class="c-unitdetail_loading">' + (window.g7FloorSelector.loading || "Chargement…") + "</div>";

			const formData = new FormData();

			formData.append("action", "g7_get_unit_data");

			formData.append("nonce", window.g7FloorSelector.nonce);

			formData.append("post_id", postId);

			try {
				const response = await fetch(window.g7FloorSelector.ajaxUrl, {
					method: "POST",
					body: formData,
					credentials: "same-origin",
					signal: requestController.signal,
				});

				const result = await response.json();

				if (!response.ok || !result.success) {
					let errorMessage = window.g7FloorSelector.error || "Une erreur est survenue.";

					if (result && result.data && result.data.message) {
						errorMessage = result.data.message;
					}

					throw new Error(errorMessage);
				}

				details.innerHTML = result.data.html;

				/*
				 * Replace la colonne au début du détail.
				 */
				const floorList = floor.querySelector(".c-floor_list");

				if (floorList) {
					floorList.scrollTop = 0;
				}
			} catch (error) {
				if (error.name === "AbortError") {
					return;
				}

				console.error(error);

				details.innerHTML = '<div class="c-unitdetail_error">' + "<p>" + (error.message || window.g7FloorSelector.error || "Une erreur est survenue.") + "</p>" + '<button type="button" class="c-unitdetail_back">' + "Retour aux unités" + "</button>" + "</div>";
			} finally {
				if (activeRequestController === requestController) {
					floor.classList.remove("-loading");
					activeRequestController = null;
				}
			}
		}

		/**
		 * Clic sur un étage du SVG général.
		 *
		 * La délégation est importante :
		 * event.target est souvent un path enfant,
		 * pas directement le groupe .niveau.
		 */
		initialSelector.addEventListener("click", function (event) {
			if (!event.target || typeof event.target.closest !== "function") {
				return;
			}

			const level = event.target.closest(".niveau");

			if (!level || !initialSelector.contains(level)) {
				return;
			}

			const floorNumber = getFloorNumber(level);

			if (!floorNumber) {
				return;
			}

			showFloor(floorNumber);
		});

		/**
		 * Navigation clavier des étages.
		 */
		initialSelector.addEventListener("keydown", function (event) {
			if (event.key !== "Enter" && event.key !== " ") {
				return;
			}

			if (!event.target || typeof event.target.closest !== "function") {
				return;
			}

			const level = event.target.closest(".niveau");

			if (!level) {
				return;
			}

			event.preventDefault();

			const floorNumber = getFloorNumber(level);

			if (floorNumber) {
				showFloor(floorNumber);
			}
		});

		/**
		 * Rend les étages accessibles au clavier.
		 */
		const levels = initialSelector.querySelectorAll(".niveau[data-floor-index]");

		levels.forEach(function (level) {
			const floorNumber = getFloorNumber(level);

			if (!floorNumber) {
				return;
			}

			level.setAttribute("role", "button");
			level.setAttribute("tabindex", "0");
			level.setAttribute("aria-label", "Afficher le niveau " + floorNumber);
		});

		/**
		 * Boutons de retour.
		 */
		backButtons.forEach(function (button) {
			button.addEventListener("click", showInitialSelector);
		});

		/**
		 * Clic sur une unité disponible.
		 */
		section.addEventListener("click", function (event) {
			if (!event.target || typeof event.target.closest !== "function") {
				return;
			}

			const detailsBack = event.target.closest(".c-unitdetail_back");

			if (detailsBack) {
				const floor = detailsBack.closest(".c-floor");

				showUnitList(floor);

				return;
			}

			const trigger = event.target.closest([".unite.-available[data-wp-pid]", ".c-floor_unitecard[data-wp-pid]"].join(","));

			if (!trigger || !section.contains(trigger)) {
				return;
			}

			loadUnitData(trigger);
		});

		/**
		 * Navigation clavier des unités.
		 */
		section.addEventListener("keydown", function (event) {
			if (event.key !== "Enter" && event.key !== " ") {
				return;
			}

			if (!event.target || typeof event.target.closest !== "function") {
				return;
			}

			const trigger = event.target.closest([".unite.-available[data-wp-pid]", ".c-floor_unitecard[data-wp-pid]"].join(","));

			if (!trigger) {
				return;
			}

			event.preventDefault();
			loadUnitData(trigger);
		});

		/*
		 * Les SVG sont déjà présents dans le DOM.
		 * On associe immédiatement les CPT à leurs zones SVG.
		 */
		floors.forEach(function (floor) {
			initializeSvgUnits(floor);
		});

		setInitialState();
	});
}

function initRowsTextAnimations() {
	const block1 = document.querySelector(".c-rowstext_block.-block1");

	const block2 = document.querySelector(".c-rowstext_block.-block2");

	const block3 = document.querySelector(".c-rowstext_block.-block3");

	if (block1) {
		gsap.to(block1, {
			scrollTrigger: {
				trigger: block1,
				start: "top 90%",
				end: "bottom 10%",
				scrub: true,
			},
			x: function (progress) {
				const wave = 1 - Math.abs(progress * 2 - 1);

				return 20 * wave;
			},
			ease: "none",
		});
	}

	if (block2) {
		const timeline2 = gsap.timeline({
			scrollTrigger: {
				trigger: block2,
				start: "top 80%",
				end: "bottom 20%",
				scrub: true,
			},
		});

		timeline2
			.to(block2, {
				x: 0,
				ease: "none",
			})
			.to(block2, {
				x: 30,
				ease: "none",
			});
	}

	if (block3) {
		const timeline3 = gsap.timeline({
			scrollTrigger: {
				trigger: block3,
				start: "top 80%",
				end: "bottom 20%",
				scrub: true,
			},
		});

		timeline3
			.to(block3, {
				x: 0,
				ease: "none",
			})
			.to(block3, {
				x: 30,
				ease: "none",
			});
	}
}

// ------------------------------
// GLOBAL CONFIG
// ------------------------------

function config() {
	/*
	 * Ne pas enregistrer un plugin absent.
	 */
	if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
		gsap.registerPlugin(ScrollTrigger);
	}

	initLenis();
	addLoadedClass();
	initBurgerMenu();
	initScrolledHeader();

	const carousel = document.querySelector(".o-carousel");

	if (carousel) {
		new Flickity(carousel, {
			cellAlign: "left",
			contain: true,
			pageDots: false,
			prevNextButtons: true,
			wrapAround: true,
		});
	}

	if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
		initIntroParallax();
		initPlansLightbox();
		initRowsTextAnimations();
		initScrollAnimations();
	}

	/*
	 * Le sélecteur utilise GSAP pour sa transition.
	 */
	if (typeof gsap !== "undefined" && document.querySelector(".c-selector_section")) {
		initFloorSelector();
	}
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", config);
} else {
	config();
}

window.addEventListener("load", function () {
	if (typeof ScrollTrigger !== "undefined") {
		ScrollTrigger.refresh();
	}
});
